import { BookingType } from "../enums/BookingScope";

/**
 * Tipologia personalizzata delle prenotazioni create dal gestionale (es.
 * "Manutenzione"). È un'etichetta libera salvata in `customType`: il
 * `bookingType` resta uno dei tre tipi standard, perché è quello che usa
 * l'app.
 */

/** Valore della voce "Personalizzata…" nel selettore del tipo. */
export const CUSTOM_BOOKING_TYPE = "Custom";

/** Tipo standard salvato in `bookingType` quando la tipologia è personalizzata. */
export const CUSTOM_TYPE_BASE_BOOKING_TYPE = BookingType.Friendly;

export const CUSTOM_TYPE_MAX_LENGTH = 40;

export const BOOKING_TYPE_OPTIONS: { label: string; value: BookingType }[] = [
  { label: "Amichevole", value: BookingType.Friendly },
  { label: "Torneo", value: BookingType.Tournament },
  { label: "Allenamento", value: BookingType.Training },
];

const DEFAULT_SUGGESTIONS = ["Manutenzione", "Evento privato", "Corso"];
const STORAGE_KEY = "gm-custom-booking-types";
const MAX_REMEMBERED = 10;

const readRemembered = (): string[] => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(parsed)
      ? parsed.filter((v): v is string => typeof v === "string")
      : [];
  } catch {
    return [];
  }
};

/** Tipologie già usate su questo browser (le più recenti prima) + suggerite. */
export const getCustomTypeSuggestions = (): string[] => {
  const remembered = readRemembered();
  const known = new Set(remembered.map((v) => v.toLowerCase()));
  return [
    ...remembered,
    ...DEFAULT_SUGGESTIONS.filter((v) => !known.has(v.toLowerCase())),
  ];
};

/** Ricorda una tipologia usata, così viene riproposta alle prossime prenotazioni. */
export const rememberCustomType = (value?: string | null) => {
  const label = value?.trim();
  if (!label) return;
  try {
    const next = [
      label,
      ...readRemembered().filter(
        (v) => v.toLowerCase() !== label.toLowerCase()
      ),
    ].slice(0, MAX_REMEMBERED);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // localStorage non disponibile: i suggerimenti restano quelli di default.
  }
};
